<template>
  <v-card class="px-2 pb-2 mb-3">
    <v-card-title primary-title>
      <span class="title">Bot Volume Report</span>
    </v-card-title>
    <v-container fluid>
      <v-layout pt-3>
        <v-autocomplete
          class="ml-0"
          :items="items"
          item-text="name"
          cache-items
          label="Select sheet"
          :loading="loadingData"
          v-model="selected"
          @change="onSheetSelected"
        ></v-autocomplete>
        <v-menu v-if="afterSelectSheet" bottom offset-y>
          <template v-slot:activator="{ on }">
            <v-autocomplete
              class="ml-1"
              :items="exchangeItem"
              item-text="exchange_name"
              label="Select exchange"
              v-model="selectedExchange"
              @change="onSelectedExchangeChange"
              clearable
            ></v-autocomplete>
          </template>
        </v-menu>
        <v-menu v-if="afterSelectSheet" bottom offset-y>
          <template v-slot:activator="{ on }">
            <v-btn color="primary" class="ml-3" v-on="on">
              {{ selectStartDate ? selectStartDate : 'Select Start Date' }}
            </v-btn>
          </template>
          <v-date-picker v-model="selectStartDate"></v-date-picker>
        </v-menu>
        <v-menu v-if="afterSelectSheet" bottom offset-y>
          <template v-slot:activator="{ on }">
            <v-btn color="primary" class="ml-3" v-on="on">
              {{ selectEndDate ? selectEndDate : 'Select End Date' }}
            </v-btn>
          </template>
          <v-date-picker v-model="selectEndDate"></v-date-picker>
        </v-menu>
        <v-btn
          v-if="afterSelectSheet"
          color="green"
          class="ml-3"
          :loading="loadingData"
          @click="
            RequestBotVolumeReport(
              selected,
              selectedExchange,
              selectStartDate,
              selectEndDate
            )
          "
        >
          Download
        </v-btn>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
import MongoService from '../../services/mongo.service';
import MongoConnector from '@/services/mongo-connector.service';
import MessageDialog from '../../libs/message-dialog/';
import { exportBotReportCsv } from '../../services/export-csv';

export default {
  data() {
    const service = new MongoConnector(null, 'spreadsheet-report-config', {});
    return {
      service,
      loadingData: false,
      selected: [], // Change to array for multiple selection
      items: [],
      afterSelectSheet: false,
      selectStartDate: null,
      selectEndDate: null,
      exchangeItem: [],
      selectedExchange: null
    };
  },
  async beforeMount() {
    this.loadingData = true;
    try {
      let result = await this.service.find({
        limit: 100,
        filter: { report_type: 'bot-volume-v2' },
        sort: { client: 1 }
      });
      result = result.map((x) => {
        return {
          sheet_id: x.sheet_id,
          name: x.name,
          tab_id: 0,
          exchange: x.exchanges
        };
      });
      this.items.push(...result);
    } catch (e) {
      console.log(e);
    }
    this.loadingData = false;
  },
  computed: {
    value() {
      return this.selected.map((item) => ({
        // Adjust the computed property for array of selected items
        sheet_id: item.sheet_id,
        tab_id: item.tab_id,
        name: item.name
      }));
    }
  },

  methods: {
    onSheetSelected(name) {
      this.afterSelectSheet = true;
      const matchingItems = this.items.filter((item) => item.name === name);
      const exchange = matchingItems[0].exchange;
      this.exchangeItem = exchange;
    },
    onSelectedExchangeChange(newExchange) {
      this.selectedExchange = newExchange;
    },
    async RequestBotVolumeReport(
      name,
      selectedExchange,
      selectStartDate,
      selectEndDate
    ) {
      if (typeof name === 'string') {
        try {
          const startDate = new Date(selectStartDate)
          const endDate = new Date(selectEndDate)
          if (startDate.getTime() > endDate.getTime()) {
            MessageDialog.showErrorMessage({
              title: name,
              text: 'Start date cannot after End date'
            });
            return false
          }
          if (endDate.getTime() - startDate.getTime() >= 1000 * 60 * 60 * 24 * 15) {
            MessageDialog.showErrorMessage({
              title: name,
              text: 'Start and end date range between 15 days'
            });
            return false
          }

          const payload = {
            method: 'bot-volume-v2',
            name,
            date: startDate.toISOString(),
            endDate: endDate.toISOString(),
            updateSpreadsheet: false
          };
          if (selectedExchange) {
            payload.exchange = selectedExchange;
          }

          this.loadingData = true
          const result =
            await MongoService.spreadsheetOperation.botReportRequest(payload);

          if (result.status === 200) {
            if (result.data.result.length > 0) {
              await exportBotReportCsv(result.data, name, selectedExchange);
              MessageDialog.showSuccessMessage({
                title: `Download Complete CSV`,
                text: `Download ${result.data.result.length} record`
              });
            } else {
              MessageDialog.showErrorMessage({
                title: name,
                text: 'no data found'
              });
            }
          } else {
            MessageDialog.showErrorMessage({ title: name, text: result.body });
          }
        } catch (error) {
          console.log(error);
        }
        this.loadingData = false;
      } else {
        MessageDialog.showErrorMessage({ text: 'Please Select Sheets' });
        this.loadingData = false;
      }
    }
  }
};
</script>
